import React from 'react';
import BreadCrumb from './BreadCrumb';
import RenewableAgenciesListing from './RenewableAgenciesListing';

function RenewableAgenciesPage() {
    return ( 
        <>
            <BreadCrumb />
            <RenewableAgenciesListing />
            {/* <Herobottom /> */}
        </>
     );
}

export default RenewableAgenciesPage;